import React from 'react';
import { FormGroup, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useStyles } from '../Styles';
import PropTypes from 'prop-types';

export default function DeleteButton(props) {
  const classes = useStyles();

  return (
    <FormGroup>
      <Button
        variant="contained"
        style={{ color: 'white', borderRadius: '15px' }}
        className={classes.rootReturn}
        size="large"
        startIcon={<ArrowBackIcon />}
        onClick={props.onClick}
        disabled={props.disabled}
      >
        Voltar
      </Button>
    </FormGroup>
  );
}
DeleteButton.defaultProps = {
  props: { disabled: false, onClick: () => {} },
};

DeleteButton.propTypes = {
  /** Recebe as propriedades para o botão de retorno* */
  props: PropTypes.object,
};
